import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { parseJwt } from '../components/utilities/utils';
import { BASE_URLS, PLATFORM_TYPE } from '../constants/constants';


const getHeadersForElectionDetailApi = () => {
  if (localStorage.userrole === "ero") {
    return {
      constType: "AC",
      constNo: parseJwt(localStorage.access_token)?.authorizedAcs?.[0]
    }
  }
  return {
    constType: parseJwt(localStorage.access_token)?.constituencyType,
    constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
  }
}

export const announceElectionServiceApi = createApi({
  reducerPath: 'announceElectionServiceApi',
  keepUnusedDataFor: 0.001,
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URLS.ANNOUNCE_ELECTION_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("currentRole", localStorage.userrole);
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if (localStorage.userrole !== "eci") {
        headers.set("statecd", parseJwt(localStorage.access_token)?.authorizedStates?.[0]);
        headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      }
      return headers;
    }
  }),
  tagTypes: ['uploadElection'],
  endpoints: (builder) => ({
    announceElectionUploadFile: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/announceElectionRequest",
        method: "POST",
        body: data,
        invalidatesTags: ['uploadElection'],
      }),
    }),



    getElectionDetails: builder.query({
      query: (data) => ({
        headers: getHeadersForElectionDetailApi(),
        url: `/v1/public/announceElection/schedule?module=${data}`,
        method: "GET",
      }),
    }),
    getAllDetailsAnnounceElection: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/announceElection",
        method: "POST",
        body: data,
        providesTags: ['uploadElection'],
      }),
    }),
    announceElectionDetailEdit: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/updateAnnounceElection",
        method: "POST",
        body: data,
        providesTags: ['uploadElection'],
      }),
    }),
    getDashBoardData: builder.query({
      query: () => ({
        url: '/v1/public/announceElection/countDashboardDataRO',
        method: 'GET',
        headers: {
          'Content-type': 'application/json;',
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    getECiCeoDeoDashboardData: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/dashboardData",
        method: "POST",
        body: data,
        headers: {
          'Content-type': 'application/json;',
          "currentRole": localStorage.userrole,
          'Authorization': 'Bearer ' + localStorage.access_token,
        },
      }),
    }),
    getBallotVerificationAC: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/ballotVerificationFlagRequest",
        method: "POST",
        body: data,
        headers: {
          'Content-type': 'application/json;',
          "currentRole": localStorage.userrole,
          'Authorization': 'Bearer ' + localStorage.access_token,
        },
      }),
    }),
    getNoVoterMarkedACs: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/serviceVoterUploadCheck",
        method: "POST",
        body: data,
        headers: {
          'Content-type': 'application/json;',
          "currentRole": localStorage.userrole,
          'Authorization': 'Bearer ' + localStorage.access_token,
        },
      }),
    }),
    GetStatesRequest: builder.query({
      query: () => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: "/v1/public/announceElection/getStatesData",
        method: "Get",
      }),
    }),
    GetPcByState: builder.query({
      query: (data) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: `/v1/public/announceElection/getStatesPcData?stateCd=${data}`,
        method: "Get",
      }),
      // providesTags: ["Form6a"],
    }),
    GetConstituencyRequest: builder.query({
      query: (stateCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: `/v1/public/announceElection/getStatesAcData?stateCd=${stateCode}`,
        method: "Get",
      }),
      providesTags: ["Form6a"],
    }),
    GetDistrictRequest: builder.query({
      query: (stateCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
       
        },
        url: `/v1/public/announceElection/getDistrictData?stateCd=${stateCode}`,
        method: "Get",
      }),
     
    }),
    GetAllInstructionRequest: builder.query({
      query: (stateCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: `/v1/public/announceElection/getAllRecords`,
        method: "Get",
      }),
     
    }),
    postInstruction: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/pressNoticeUpload",
        method: "POST",
        body: data,
      }),
    }),
    getInstructionById: builder.query({
      query: (data) => ({
        url: `/v1/public/announceElection/getRecord/${data}`,
        method: "Get",
      }),
    }),
    updateInstruction: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/updateRecordDetails",
        method: "POST",
        body: data,
      }),
    }),
    deleteInstruction: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/archiveRecord",
        method: "Post",
        body: data,
      }),
    }),
    downloadInstruction: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/totalDownloadRecord",
        method: "Post",
        body: data,
      }),
    }),
    markScanningCompleted: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/epbScanningCountDetails",
        method: "Post",
        body: data,
        headers: {
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    GetScannedCompleteData: builder.query({
      query: (constType) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          constType:constType
        },
        url: `/v1/public/announceElection/getPreCountingFlagCeo`,
        method: "Get",
      }),
     
    }),
    enableScanning: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/enablePreCounting",
        method: "Post",
        body: data,
        headers: {
          'constType': data?.constType,
        },
      }),
    }),
    saveBallotCandidates: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/ballotDetails",
        method: "Post",
        body: data,
        headers: {
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    GetBallotCandidate: builder.query({
      query: (constType) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        url: `/v1/public/announceElection/getBallotDetails`,
        method: "Get",
      }),
     
    }),

    updateLoginStatusForCS: builder.query({
      query: (data) => ({
        headers: {
          Authorization: "Bearer " + data,
          // constType:constType
        },
        url: `/v1/public/announceElection/saveLoginDetails`,
        method: "Get",
      }),
     
    }),

    getEPBReceivedTillDate: builder.mutation({
      query: (data) => ({
        url: "/v1/public/announceElection/getEPBReceivedTillDate",
        method: "Post",
        body: data,
        headers: {
          constType: parseJwt(localStorage.access_token)?.constituencyType,
          constNo: parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    getPhaseNodetails: builder.query({
      query: (data) => ({
        headers: {
          Authorization: "Bearer " + data,
          // constType:constType
        },
        url: `/v1/public/announceElection/getPhaseNoDetails`,
        method: "Get",
      }),
     
    }),
  }),
});
export const {
  useAnnounceElectionUploadFileMutation,
  useGetAllDetailsAnnounceElectionMutation,
  useGetDashBoardDataQuery,
  useGetECiCeoDeoDashboardDataMutation,
  useAnnounceElectionDetailEditMutation,
  useGetElectionDetailsQuery,
  useGetBallotVerificationACMutation,
  useGetNoVoterMarkedACsMutation,
  useGetConstituencyRequestQuery,
  useGetPcByStateQuery,
  useGetStatesRequestQuery,
  useGetDistrictRequestQuery,
  useGetAllInstructionRequestQuery,
  usePostInstructionMutation,
  useGetInstructionByIdQuery,
  useUpdateInstructionMutation,
  useDeleteInstructionMutation,
  useDownloadInstructionMutation,
  useMarkScanningCompletedMutation,
  useGetScannedCompleteDataQuery,
  useEnableScanningMutation,
  useSaveBallotCandidatesMutation,
  useGetBallotCandidateQuery,
  useLazyUpdateLoginStatusForCSQuery,
  useGetEPBReceivedTillDateMutation,
  useLazyGetPhaseNodetailsQuery
} = announceElectionServiceApi
